/**
 * DriverMonoView - Content renderer for driver role
 *
 * When wrapped by DriverLayout, receives activeTab from the sidebar.
 * Renders the appropriate driver-specific component based on active tab.
 * Handles mission detail overlay (selecting a mission from list or dashboard).
 */
import React, { useState } from 'react';
import DriverDashboard from './DriverDashboard.jsx';
import DriverMissionList from './DriverMissionList.jsx';
import DriverMissionDetail from './DriverMissionDetail.jsx';
import DriverVehicleCard from './DriverVehicleCard.jsx';
import DriverDocuments from './DriverDocuments.jsx';
import DriverProfileSummary from './DriverProfileSummary.jsx';
import DriverFuelHistory from './DriverFuelHistory.jsx';
import DriverFines from './DriverFines.jsx';
import DriverReportIssue from './DriverReportIssue.jsx';

export default function DriverMonoView({ activeTab = 'home' }) {
  const [selectedMissionId, setSelectedMissionId] = useState(null);

  const handleMissionSelect = (missionId) => {
    setSelectedMissionId(missionId);
  };

  const handleMissionBack = () => {
    setSelectedMissionId(null);
  };

  // If a mission is selected, show detail overlay
  if (selectedMissionId) {
    return (
      <DriverMissionDetail
        missionId={selectedMissionId}
        onBack={handleMissionBack}
      />
    );
  }

  switch (activeTab) {
    case 'home':
      return <DriverDashboard onNavigateToMission={handleMissionSelect} />;
    case 'missions':
      return <DriverMissionList onSelectMission={handleMissionSelect} />;
    case 'vehicle':
      return <DriverVehicleCard />;
    case 'fuel':
      return <DriverFuelHistory />;
    case 'report':
      return <DriverReportIssue />;
    case 'fines':
      return <DriverFines />;
    case 'documents':
      return <DriverDocuments />;
    case 'profile':
      return <DriverProfileSummary />;
    default:
      return <DriverDashboard onNavigateToMission={handleMissionSelect} />;
  }
}
